import { apiClientVersioned, fileUploadClient, returnData } from '../index'

import type { IAudioTranscription, IUploadedFile } from '../types/file'

export const UploadApi = {
  file: (file: File, options?: { signal?: AbortSignal }, useRag?: boolean) =>
    returnData(
      fileUploadClient.post<IUploadedFile[]>(
        `/files`,
        { files: file },
        {
          signal: options?.signal,
          ...(useRag !== undefined ? { params: { use_rag: useRag } } : {}),
        },
      ),
    ),
  transcribe: async (file: Blob, signal?: AbortSignal) => {
    // Convertim Blob-ul în ArrayBuffer pentru raw bytes
    const arrayBuffer = await file.arrayBuffer()

    return returnData(
      apiClientVersioned.post<IAudioTranscription>(
        '/llms/voice2text',
        arrayBuffer,
        {
          signal,
          headers: {
            'Content-Type': 'application/octet-stream',
          },
        },
      ),
    )
  },
}
